__turbopack_context__.v({
  "dropdownMenu": "jwpSKq_dropdownMenu",
  "sidenavItem": "jwpSKq_sidenavItem",
});
